<template>
	<div @click="disabled ? disableClick() : null">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'DisabledButtonWrapper',
	props: {
		disabled: {
			type: Boolean,
			required: true
		}
	},
	methods: {
		disableClick() {
			this.$emit('disabled-click');
		}
	}
};
</script>

<style scoped></style>
